import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component({
  components: {
    Modal: () => import('@/components/modalBase/modalBase'),
    ButtonNumber: () => import('@/components/buttonNumber/buttonNumber'),
    AddonsList: () => import('@/components/addonsList/addonsList')
  }
})
export default class ModalAddons extends Vue {
  @Prop({ default: false }) isOpen
  @Prop({ default: false }) isEdit
  @Prop({ default: () => ({}) }) product

  @Getter getCountry
  @Action action_getAddonsProduct
  @Mutation CART_TEMPORAL
  @Getter getProductAddons
  @Getter getCartTemporal

  isOpenAddons = false
  isValidate = false
  errors = []
  messageError = ''
  addons = []
  total = 0

  get textBtn () {
    return this.isEdit ? 'Editar' : 'Agregar'
  }

  @Watch('isOpen')
  async onIsOpen (val) {
    if (val && this.product) {
      // cargar adicionales asociados al producto
      await this.action_getAddonsProduct(this.product.id)
      this._price()
    }
  }

  _price () {
    // capturamos el precio del producto
    let price = parseFloat((this.product as any).price)
    // revisamos si el usuario tiene adicionales seleccionado
    if (this.addons) {
      this.addons.map((item) => {
        // validamos si el grupo modificador es multiseleccion o seleccion unica
        // luego sumamos cada addon con el precio del producto
        if (item.is_multiple) {
          item.addons.map((a) => {
            let priceAddon = parseFloat(a.price)
            price = price + priceAddon
          })
        } else {
          let priceAddon = parseFloat(item.addons.price)
          price = price + priceAddon
        }
      })
    }
    this.total = this.$currency.format(price, { code: this.getCountry.currency })
  }

  // llenar un array con los estados de las validaciones de los addons esto nos ayuda a verificar si todos los addons obligatorios fueron seleccionados
  _onValid (val, index) {
    this.errors[index] = val
    // cada vez que el usuario active el selector de los addons validamos si ya quedo listo
    this._onValidate()
  }

  _onValidate () {
    // validar si hace falta seleccionar adicionales obligatorios
    const errors = this.errors
    if (errors.length == 0 || errors.includes(true)) {
      this.messageError = 'Seleccione los adicionales obligatorios'
      return false
    } else {
      this.messageError = ''
      return true
    }
  }

  _seletedAddons (val) {
    // cargamos los addons que los componenes hijos nos envian a un arrray y prepararlos cuando el usuario agregue el producto
    let addons = this.addons
    const index = addons.findIndex((item) => item.id === val.id)

    // validamos si la innformacion que vamos agregar ya existe o el es el primer item
    if (index !== -1) addons.splice(index, 1, val)
    else addons.push(val)
    // luego de hacer la validacion actualizamos el array de modificadores con los addons seleccionados por el usuario
    this.addons = addons
    // actualizamos el precio
    this._price()
  }

  _addProduct () {
    // ejecutamos un evento a los addons para verificar si ya estan seleccionados los obligatorios
    this.isValidate = !this.isValidate

    if (this._onValidate()) {
      // verificamos la información del carrito
      let cart = this.getCartTemporal
      const product = this.product
      const index = cart.findIndex((item) => item.product.id === product.id)

      // preparamos la data que camos agregar al carrito
      // si estamos editando le dejamos el mismo numero en la cantidad si vamos agregar por primera vez lo dejamos en 1
      const data = {
        product,
        addons: this.addons,
        qty: this.isEdit ? cart[index].qty : 1
      }
      // si estamos editando reemplazamos la informacion del carrito
      // de lo contrario agregamos uno nuevo
      if (this.isEdit) {
        cart.splice(index, 1, data)
        this.CART_TEMPORAL(cart)
      } else {
        this.CART_TEMPORAL([...cart, data])
      }
      this._onClose()
    }
  }

  _onClose () {
    this.addons = []
    this.$emit('onClose', false)
  }

}
